import { i18nStore, selectCurrentLanguage } from '../../../modules/stores/i18nStore';
import { selectIsGuestUser, selectUserContext, selectUserToken, userStore } from '../../stores/userStore';
import { AnalyticsWeightings } from '../analyticsWeightings';

export const EXTENSION_TYPE_LISTING = 'listing/extensions/force/listings/Listing';
export const EXTENSION_TYPE_CONSULTANT = 'listing/extensions/consultant/listings/Listing';

export interface CoveoAnalyticsCustomData {
    listingCategoryName?: string;
    datetime: string;
    orgedition?: string;
    orgId?: string;
    orgstatus?: string;
    context_topCategories?: string[];
    context_mainCategory?: string;
    context_products?: string[];
    context_region?: string;
    context_edition?: string;
    context_industry?: string;
    context_userRole?: string;
    context_userLinkedOrgs?: string[];
    lastInstalledListings?: string[];
}
export interface CoveoAnalyticsEvent {
    customData: CoveoAnalyticsCustomData;
    language: string;
    originLevel1: string;
    outcome: number;
    anonymous: boolean;
    userAgent: string;
    username: string;
    clientId: string;
}

export abstract class CoveoEventType {
    // @ts-expect-error * Automated Type Error Fix
    abstract canHandle(event): boolean;
    abstract getPath(): string;
    // @ts-expect-error * Automated Type Error Fix
    abstract getBody(event): CoveoAnalyticsEvent;

    // @ts-expect-error * Automated Type Error Fix
    baseBody(event): CoveoAnalyticsEvent {
        return {
            customData: {
                ...this.getUserCustomData(),
                datetime: event.timestamp,
            },
            language: this.getCurrentLanguage(),
            // @ts-expect-error * Automated Type Error Fix
            originLevel1: this.getOriginLanguage(),
            outcome: AnalyticsWeightings.defaultPoints,
            anonymous: !event.authenticated,
            userAgent: event.browser,
            username: selectUserToken(userStore.getState()),
            clientId: selectUserToken(userStore.getState()),
        };
    }

    private getUserCustomData() {
        const isGuestUser = selectIsGuestUser(userStore.getState());
        if (!isGuestUser) {
            const userContext = selectUserContext(userStore.getState());
            return {
                // @ts-expect-error * Automated Type Error Fix
                orgid: userContext.orgid,
                // @ts-expect-error * Automated Type Error Fix
                orgedition: userContext.orgedition,
                // @ts-expect-error * Automated Type Error Fix
                orgstatus: userContext.orgstatus,
                // @ts-expect-error * Automated Type Error Fix
                context_topCategories: userContext.topCategories,
                // @ts-expect-error * Automated Type Error Fix
                context_mainCategory: userContext.mainCategory,
                // @ts-expect-error * Automated Type Error Fix
                context_products: userContext.products,
                // @ts-expect-error * Automated Type Error Fix
                context_region: userContext.region,
                // @ts-expect-error * Automated Type Error Fix
                context_edition: userContext.orgedition,
                // @ts-expect-error * Automated Type Error Fix
                context_industry: userContext.industry,
                // @ts-expect-error * Automated Type Error Fix
                context_userRole: userContext.userRole,
                // @ts-expect-error * Automated Type Error Fix
                context_userLinkedOrgs: userContext.userLinkedOrgs,
                // @ts-expect-error * Automated Type Error Fix
                lastInstalledListings: userContext.lastInstalledListings,
            };
        }
        return {};
    }

    private getCurrentLanguage() {
        return selectCurrentLanguage(i18nStore.getState());
    }

    private getOriginLanguage() {
        const languageMap = new Map([
            ['en', 'English'],
            ['ja', 'Japanese'],
        ]);
        return languageMap.get(this.getCurrentLanguage());
    }

    // @ts-expect-error * Automated Type Error Fix
    getListingCategories(categories) {
        return categories
            ? // @ts-expect-error * Automated Type Error Fix
              categories.map((category) => {
                  if (typeof category == 'string') {
                      return category;
                  }
                  return category.name;
              })
            : [];
    }
}
